import UploadProducts from './UploadProducts'

export default UploadProducts
